/* ADD QUIZZ ANSWER USER */
export const ADD_QUIZZ_ANSWER_USER = "ADD_QUIZZ_ANSWER_USER"
export const ADD_QUIZZ_ANSWER_USER_SUCCESS = "ADD_QUIZZ_ANSWER_USER_SUCCESS"
export const ADD_QUIZZ_ANSWER_USER_CLEAN = "ADD_QUIZZ_ANSWER_USER_CLEAN"
export const ADD_QUIZZ_ANSWER_USER_ERROR = "ADD_QUIZZ_ANSWER_USER_ERROR"
